import * as Yup from 'yup';
import { PqrTime } from '../../../../../../shared/types/paramPqrTimes';

export const initialValues: PqrTime = {
    active: true,
    half: '',
    name: '',
    procedure: '',
    observation: '',
    receptionChannel: '',
    rule: '',
    subtypeDp: '',
    status: '',
    type: '',
    typeDay: '',
};

export const validationSchema = Yup.object({
    half: Yup.string().required('El Medio es obligatorio'),
    procedure: Yup.string().required('El trámite es obligatorio'),
    observation: Yup.string().required('La observación es obligatoria'),
    receptionChannel: Yup.string().required(
        'El canal de recepción es obligatorio'
    ),
    subtypeDp: Yup.string().required('El Subtipo Dp es obligatorio'),
    status: Yup.string().required('El estado es obligatorio'),
    type: Yup.string().required('El tipo de PQR es obligatorio'),
    typeDay: Yup.string().required('El tipo de día es obligatorio'),
});
